import React from "react";

export const ERROR_ICON_ID = "portal/m/cbcc/Subtract.png";
export const CROUTON_CSS_PROPERTIES: React.CSSProperties = {
    width: "100%",
    margin: "0 8px",
};
export const CROUTON_DURATION = 1000;

export const DISCOUNT_PLACEHOLDER = "[[APPLICABLE_DISCOUNT]]";

export const appendDiscount = (text: string, discount?: number) => text.replace(DISCOUNT_PLACEHOLDER, `${discount}`);

export const CART_CBCC_REMIND_ME_NUDGE_CLICK = "CART_CBCC_REMIND_ME_NUDGE_CLICK";
